// Packages
import React from 'react';

// Redux

// Components
import { KiteButton, KiteCard, KiteIcon } from '@kite/react-kite';

// Types
import { ITcoDeviceSelection } from 'types';

// Styles
import './DeviceCard.scss';
import { IDIYProduct, ISpectrumProduct } from 'types/TcoProducts';
import { tcoFormattedPrice } from 'utils/defaultsAndConstants/tcoConstants';

export interface IDeviceCardProps {
  /** Data containing details for the current product */
  selection: ITcoDeviceSelection;
  tcoSpectrumProducts: ISpectrumProduct[];
  tcoDiyProducts: IDIYProduct[];
  onEdit: (updatedSelection: ITcoDeviceSelection) => void;
  onDelete: (deletedSelection: ITcoDeviceSelection) => void;
  isPublished: boolean;
}

/** Card for displaying UC Profiles */

const DeviceCard = ({
  selection,
  tcoSpectrumProducts,
  tcoDiyProducts,
  onEdit,
  onDelete,
  isPublished = true,
}: IDeviceCardProps) => {
  // =============================================
  // State/Refs/Hooks
  // =============================================

  // =============================================
  // Interaction Handlers
  // =============================================

  // =============================================
  // Render Methods
  // =============================================

  // =============================================
  // Return
  // =============================================
  return (
    <KiteCard className="device-card">
      <div className="device-card__upper">
        <h3 className="device-card__upper_name">
          {' '}
          {selection?.name}
          <div className="device-card__upper_name_quantity">
            <KiteIcon name="phone-office-f"></KiteIcon>
            {selection?.quantity} Devices
          </div>
          {!isPublished && <KiteIcon name="lock"></KiteIcon>}
        </h3>

        {isPublished && (
          <KiteButton
            type="standalone-link"
            aria-label="edit product"
            onClick={() => onEdit(selection)}
          >
            <KiteIcon name="edit" />
          </KiteButton>
        )}

        <KiteButton
          type="standalone-link"
          aria-label="delete product"
          onClick={() => onDelete(selection)}
        >
          <KiteIcon name="trash" />
        </KiteButton>
      </div>

      <div className="device-card__lower">
        <div className="device-card__lower-pricing">
          <div className="device-card__lower-pricing-subtitle">
            SPECTRUM :{' '}
            {tcoSpectrumProducts &&
              tcoSpectrumProducts.find((s) => s.id === selection.spectrumId)
                ?.name}
          </div>
          <div className="device-card__lower-pricing-cost">
            <div>
              Monthly Subtotal
              <div className="device-card__lower-pricing-cost-value">
                $
                {tcoFormattedPrice(
                  selection?.monthlyCost * selection?.quantity
                )}
              </div>
            </div>

            <div>
              Installation Subtotal
              <div className="device-card__lower-pricing-cost-value">
                $
                {tcoFormattedPrice(
                  selection?.installationCost * selection?.quantity
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="vertical"></div>
        <div className="device-card__lower-pricing">
          <div className="device-card__lower-pricing-subtitle">
            DIY :{' '}
            {tcoDiyProducts &&
              tcoDiyProducts.find((s) => s.id === selection.diyId)?.name}
          </div>
          <div className="device-card__lower-pricing-cost">
            <div>
              {' '}
              Hardware Subtotal
              <div className="device-card__lower-pricing-cost-value">
                $
                {tcoFormattedPrice(
                  selection?.hardwareCost * selection?.quantity
                )}
              </div>
            </div>
            <div>
              Licensing Subtotal
              <div className="device-card__lower-pricing-cost-value">
                $
                {tcoFormattedPrice(
                  selection?.licenseCost * selection?.quantity
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </KiteCard>
  );
};

export default DeviceCard;
